import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import WidgetBox from '@wix/da-gruser-shared/pkg/components/WidgetBox';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import PremiumFolderDataIcon from '../../../GallectionFolderDropdown/_partials/PremiumFolderDataIcon';
import ExhibitionistStrip from '../ExhibitionistStrip';
import s from './ExhibitionistStripBox.scss';
const ExhibitionistStripBox = ({ moduleId, widgetBoxProps })=>{
    const { t } = useTranslation();
    const { moduleData } = useModuleData(moduleId);
    const { title, sourceType, premiumFolderData } = moduleData;
    return /*#__PURE__*/ React.createElement(WidgetBox, _object_spread({
        header: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
            premiumFolderData: premiumFolderData,
            size: IconSize.COMPACT,
            className: s['premium-folder-icon']
        }), title || t(`widgets.exhibitionist.source.${sourceType}`)),
        moduleId: moduleId
    }, widgetBoxProps), /*#__PURE__*/ React.createElement(ExhibitionistStrip, {
        moduleId: moduleId
    }));
};
ExhibitionistStripBox.displayName = 'ExhibitionistStripBox';
export default ExhibitionistStripBox;
